/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Sampling_FastInputs */

const en_ocr_sampling_fast = /** @type {(inputs: Ocr_Sampling_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2s (Fast)`)
};

const fr_ocr_sampling_fast = /** @type {(inputs: Ocr_Sampling_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2s (Rapide)`)
};

const de_ocr_sampling_fast = /** @type {(inputs: Ocr_Sampling_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2s (Schnell)`)
};

const it_ocr_sampling_fast = /** @type {(inputs: Ocr_Sampling_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 secondi (veloce)`)
};

const ru_ocr_sampling_fast = /** @type {(inputs: Ocr_Sampling_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 с (быстро)`)
};

const es_ocr_sampling_fast = /** @type {(inputs: Ocr_Sampling_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2s (Rápido)`)
};

const zh_cn2_ocr_sampling_fast = /** @type {(inputs: Ocr_Sampling_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2秒（快）`)
};

const ja_ocr_sampling_fast = /** @type {(inputs: Ocr_Sampling_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2秒（高速）`)
};

const hi_ocr_sampling_fast = /** @type {(inputs: Ocr_Sampling_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 सेकंड (तेज़)`)
};

const pt_pt2_ocr_sampling_fast = /** @type {(inputs: Ocr_Sampling_FastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2s (Rápido)`)
};

/**
* | output |
* | --- |
* | "2s (Fast)" |
*
* @param {Ocr_Sampling_FastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_sampling_fast = /** @type {((inputs?: Ocr_Sampling_FastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Sampling_FastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_sampling_fast(inputs)
	if (locale === "de") return de_ocr_sampling_fast(inputs)
	if (locale === "it") return it_ocr_sampling_fast(inputs)
	if (locale === "ru") return ru_ocr_sampling_fast(inputs)
	if (locale === "es") return es_ocr_sampling_fast(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_sampling_fast(inputs)
	if (locale === "ja") return ja_ocr_sampling_fast(inputs)
	if (locale === "hi") return hi_ocr_sampling_fast(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_sampling_fast(inputs)
	return en_ocr_sampling_fast(inputs)
});